import * as React from 'react';
import './_CustomPropertyTypeSelect.scss';
import { ICustomPropertyTypeSelectProps } from './types';
import { CLASS_CUSTOM_PROPERTY, CLASS_CUSTOM_PROPERTY_ITEM } from '../constants';
import { AnalyzeRender } from '../../../../../helpers/memoizeHelper';
import { Button, ButtonDropdown, Icon, SelectList, SelectListItem } from 'kui';
import { CUSTOM_PROPERTY_TYPES } from './constants';
import {
    ID_ASIDE_PANEL_PORTAL
} from '../../../../../aside_panel/asidePanel/components/AsidePanelActionsButton/constants';

//@ts-ignore
const analyzeRender = window.Settings.development ? new AnalyzeRender(`CardCustomPropertyTypeSelect`) : null;

export function CustomPropertyTypeSelect ({
    cardId,
    isOpened,
    type,
    onChange,
}: ICustomPropertyTypeSelectProps) {
    if (analyzeRender) analyzeRender.call(`CardCustomPropertyTypeSelect ${cardId}`);

    const className = CLASS_CUSTOM_PROPERTY_ITEM + '-type-select';
    const classItem = className + '-item';

    const [isOpen, setOpen] = React.useState(null);

    React.useEffect(() => {
        if (isOpened === isOpen) return;
        setOpen(isOpened);
    }, [isOpened]);

    const { icon, localIcon } = CUSTOM_PROPERTY_TYPES.find(item => item.value === type);
    const LocalIcon = localIcon && require(`!!@svgr/webpack!./${localIcon}.svg`).default;
    const iconEl = icon ? <Icon xlink={icon} size={24} /> : <span><LocalIcon /></span>;

    return <ButtonDropdown
        className={`${className} ${onChange ? className + '--button' : ''}`}
        opened={isOpen}
        onOpen={() => setOpen(true)}
        onClose={() => setOpen(false)}
        directionHorizontal={'left'}
        disabled={!onChange}
        dropdownClassName={className + '-dropdown'}
        portal
        portalId={ID_ASIDE_PANEL_PORTAL}
        notBlurClasses={isOpened ? [CLASS_CUSTOM_PROPERTY + '__form-label'] : []}
    >
        <Button variant={'icon'}>
            {iconEl}
        </Button>
        <SelectList active={CUSTOM_PROPERTY_TYPES.findIndex(item => item.value === type)}>
            {CUSTOM_PROPERTY_TYPES.map(type => {
                const { name, icon, value, localIcon } = type;
                const LocalIcon = localIcon && require(`!!@svgr/webpack!./${localIcon}.svg`).default;
                return <SelectListItem
                    className={`
                        ${classItem}
                        ${LocalIcon ? classItem + '--local-icon' : ''}
                    `}
                    key={value}
                    iconSize={24}
                    icon={icon}
                    onClick={() => onChange(value)}
                >
                    <>
                        {LocalIcon && <span className={classItem + '-local-icon'}><LocalIcon /></span>}
                        {name}
                    </>
                </SelectListItem>
            })}
        </SelectList>
    </ButtonDropdown>;
};
